<template>
  <section class="columns">
    <exam-card class="column" />
    <div class="column">
      <surgery-card />
      <document-card />
    </div>
  </section>
</template>

<script>
import ExamCard from './ExamCard'
import DocumentCard from './DocumentCard'
import SurgeryCard from './SurgeryCard'

export default {
  name: 'FastCards',
  components: {
    ExamCard,
    DocumentCard,
    SurgeryCard
  },
  computed: {
  }
}
</script>
